import React from 'react';

const Skeleton = ({ width = '100%', height = '20px', className = '' }) => {
  return (
    <div 
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        animation: 'skeleton-pulse 1.5s ease-in-out infinite'
      }}
    />
  );
};

export default Skeleton;
